// THIS SCRIPT IS GENERATED BY THE GENESYS CLOUD CONFIGURATION. DO NOT MODIFY THIS FILE DIRECTLY
// IF YOU NEED TO MAKE CHANGES TO THE GENESYS SCRIPT, OR BEHAVIOR, GET A NEW SCRIPT FROM THE CONFIGURATION IN THE GENESYS CLOUD PORTAL.
import meta from '@nn/psdl-utility/src/meta.helper';
import { genesysConfig } from './genesys-config';

export function loadGenesysScript() {
  const env = (meta.getMetaContentByName('env') || '').toLowerCase();
  const isProduction = ['production', 'prod', 'prd'].includes(env);
  const siteEnv = isProduction ? 'production' : 'staging';
  const config = siteEnv === 'production'
    ? genesysConfig.production
    : genesysConfig.staging;

  (function (g, e, n, es) {
    g._genesysJs = e;
    g[e] =
      g[e] ||
      function () {
        (g[e].q = g[e].q || []).push(arguments);
      };
    g[e].t = 1 * new Date().getTime();
    g[e].c = es;
    const ys = document.createElement('script');
    ys.async = true;
    ys.src = n;
    ys.charset = 'utf-8';
    document.head.appendChild(ys);
  })(window, 'Genesys', config.scriptUrl, {
    environment: config.environment,
    deploymentId: config.deploymentId,
  });
}